import {createMuiTheme} from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#0074ff',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contast with palette.primary.main
    },
    secondary: {
      main: '#ffffff',
      dark: '#cccccc',
    },
    // error: will use the default color
  },
   // https://material.io/design/typography/the-type-system.html#type-scale
   typography: {
    // h3
    display2: {
      color: '#00020C',
      fontSize: 48,
      lineHeight: 1.1666666667,
    },
    // h4
    display1: {
      color: '#00020C',
      fontSize: 34,
      lineHeight: 1.1764705882,
      letterSpacing: 0.25,
    },
    // h5
    headline: {
      fontSize: 24,
      lineHeight: 1.1666666667,
    },
    // h6
    title: {
      fontSize: 20,
      lineHeight: 1.2,
      letterSpacing: 0.15,
    },
    // subtitle
    subheading: {
      fontSize: 16,
      lineHeight: 1.5,
      letterSpacing: 0.15,
    },
    // body 2 
    body2: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.4285714286,
      letterSpacing: 0.24,
    },
    // body 1
    body1: {
      fontSize: 16,
      fontWeight: 400,
      lineheight: 1.75,
      letterSpacing: 0.44,
    },
    caption: {
      fontSize: 12,
      lineHeight: 1.3333333333,
      letterSpacing: 0.4,
      color: '#00020C'
    },
  },
});

export default theme;


// WEBPACK FOOTER //
// ./src/theme.js